module.exports = __webpack_public_path__ + "img/iconfinder.e210fa30.svg";